module.exports = __webpack_public_path__ + "static/img/我们是谁-公司图.413aef2.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/who_are_we/我们是谁-公司图.jpg
// module id = 7WbL
// module chunks = 94